import { useContext } from 'react'
import { Footer } from 'antd/es/layout/layout'
import { LayoutContext } from 'contexts'
import { StyledButtonsContainer, StyledButton, StyledLightButton } from './CustomFooter.styles'
import { CustomFooterProps } from './CustomFooter.types'

const CustomFooter = ({ handlePdfReport, handleRequote, loading, disabled }: CustomFooterProps) => {
  const { sideBarWidth } = useContext(LayoutContext)
  return (
    <Footer
      style={{
        backgroundColor: '#fff',
        position: 'fixed',
        bottom: 0,
        left: `${sideBarWidth}px`,
        right: 0,
        width: '100%',
        padding: '0 40px',
        borderTop: '1px solid #a8d6ea',
      }}
    >
      <StyledButtonsContainer sideBarWidth={sideBarWidth}>
        <StyledLightButton onClick={handleRequote}>Requote</StyledLightButton>
        <StyledButton loading={loading} onClick={handlePdfReport} disabled={disabled}>
          Print Full Comparison
        </StyledButton>
      </StyledButtonsContainer>
    </Footer>
  )
}

export default CustomFooter
